__webpack_require__.p = "/reports-resizable-details-columns/referrals-hub/";